<template>
  <div id="mainContent">
    <el-row>
      <div class="headTitle">
        <span style="font-size: 20px;margin-right: 20px;">{{ basicinfo.deviceName }}</span>
        <span style="font-size: 18px;margin-right: 20px;">({{ basicinfo.deviceSn }})</span>
        <span class="fontStyle1">{{ $t("yhubReport.Machine") }}:{{ basicinfo.mechBrand }} {{ basicinfo.mechModel }}</span><!--设备-->
        <span class="fontStyle2" />
        <span class="fontStyle1">{{ $t("yhubReport.BatteryInformation") }}:{{ basicinfo.batteryBrand }}  {{ basicinfo.batteryModels }} </span><!--电池型号-->
        <span v-if="basicinfo.batteryCapacity!=null" class="fontStyle1">&nbsp;&nbsp;{{ basicinfo.batteryCapacity }} Ah </span><!-- 容量-->
        <span class="fontStyle1">&nbsp;&nbsp;{{ basicinfo.batteryVoltage }} V </span><!--系统电压-->
        <span class="fontStyle2" />
        <span class="fontStyle1">{{ $t("yhubReport.FirmwareVersion") }}:V{{ basicinfo.fwVersion }}</span><!--固件-->
      </div>
    </el-row>
    <div style="background: #fff;margin-top: 20px;padding: 20px 0 0 20px;" class="searchWarp">
      <el-date-picker v-model="selectDayWeekReport" type="daterange" :range-separator="$t('AllDevices.to')" :start-placeholder="$t('AllDevices.startDate')" :end-placeholder="$t('AllDevices.endDate')" @change="changeSearchWeekReport" />
      <el-tabs v-model="activeTab" type="card" class="selectTab" @tab-click="handleClick">
        <el-tab-pane :label="$t('yhubReport.yesterday')" name="prevDay" />
        <el-tab-pane :label="$t('yhubReport.aWeek')" name="prevWeek" />
        <el-tab-pane :label="$t('yhubReport.aMonth')" name="prevMonth" />
      </el-tabs>
    </div>
    <lithiumChartChargeDisTem :list-query-tem="listQueryTem" :mcu-id="$route.query.mcuId" :show-all="showAll" :full-charge-time="basicinfo.fullChargeTime" />
    <lithiumReportTem :list-query="listQueryTem" :show-all="showAll" />
    <lineChartRestCount v-if="$store.state.isAdmin" :line-date="lineDate" :height="lineHeight" style="margin-top:10px;background: #fff;" />
    <!-- <el-dialog :close-on-click-modal="false" title="温馨提示" :visible.sync="dialogVisible" width="30%">
      <span>没有找到记录信息，请选择其它设备或重新设置起止时间。</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">知道了</el-button>
      </span>
    </el-dialog> -->
  </div>

</template>

<script>
import echarts from 'echarts'
import { deviceStatistic } from '@/api/allDevice'
import { findDeviceInfo } from '@/api/yhub'
import lineChartRestCount from '@/components/lineChartRestCount'
import lithiumReportTem from './components/lithiumReportTem'
import lithiumChartChargeDisTem from './components/lithiumChartChargeDisTem'

import apiproto from '@/proto/apiproto'
import protobuf from 'protobufjs'

const GNSSProto = apiproto.lookup('com.yhub.pb.APIResponse')
export default {
  components: {
    lineChartRestCount,
    lithiumReportTem,
    lithiumChartChargeDisTem
  },
  data() {
    this.apiproto
    this.protobuf
    return {
      listLoading: false,
      dialogVisible: false,
      deviceName: this.$route.query.deviceName,
      mcuId: this.$route.query.mcuId,
      listQuery: {
        mcuId: this.$route.query.mcuId,
        startDate: this.$route.query.endTime - 7 * 24 * 60 * 60 * 1000 + 1,
        endDate: this.$route.query.endTime,
        showAll: false
      },
      listQueryTem: {
        mcuId: this.$route.query.mcuId,
        startDate: this.$route.query.endTime - 7 * 24 * 60 * 60 * 1000 + 1,
        endDate: this.$route.query.endTime,
        showAll: false,
        sn: this.$route.query.sn
      },
      option: null,
      reportLoading: false,
      lineHeight: '300px',
      lineDate: [],
      columnLineNoData: false,
      basicinfo: {},
      selectDayWeekReport: [], // 日期选择,
      weekReportStartTime: 0,
      weekReportEndTime: 0,
      todayLast: new Date().setHours(0, 0, 0) + 24 * 60 * 60 * 1000 - 1000, // 当天23:59:59
      upadateLast: new Date(Number(this.$route.query.endTime)).setHours(0, 0, 0) + 24 * 60 * 60 * 1000 - 1000, // 最后更新日的23:59:59
      activeTab: '',
      todayTimeE: new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000, // 今天23:59:59
      prevWeekS: new Date().setHours(0, 0, 0, 0) - 6 * 24 * 60 * 60 * 1000, // 一周开始时间
      prevMonthS: new Date(new Date().setHours(0, 0, 0, 0)).setMonth(new Date().getMonth() - 1), // 一个月开始时间
      showAll: false
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    language(newValue, oldValue) {
      var oldLineDate = [...this.lineDate]
      this.lineDate = []
      this.lineDate = oldLineDate
    }
  },
  created() {
    if (this.$route.query.showAll == 'true') this.showAll = true
    this.listQuery.endDate = this.listQueryTem.endDate = this.weekReportEndTime = this.$route.query.endTime ? this.upadateLast : this.todayLast
    console.log(this.todayLast)
    this.listQuery.startDate = this.listQueryTem.startDate = this.weekReportStartTime = this.$route.query.endTime ? (this.upadateLast - 1000 * 60 * 60 * 24 * 7 + 1000) : (this.todayLast - 7 * 24 * 60 * 60 * 1000 + 1000)
    this.selectDayWeekReport = [this.weekReportStartTime, this.weekReportEndTime]
    this.changeActiveTab()
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true
    next()
  },
  mounted() {
    console.log(this.$route.query)
    this.listQuery = {
      // deviceName: this.$route.query.deviceName,
      mcuId: this.$route.query.mcuId,
      startDate: this.$route.query.startTime,
      endDate: this.$route.query.endTime,
      'showAll': false,
      'timeZone': 'GMT+0'
      // 'endDate': 1587108260000,
      // 'mcuId': '05d6ff393430475043165127',
      // 'startDate': 1587105578538,

    }
    console.log(this.listQuery)
    this.initDeviceStatistic()
    this.queryList()
  },
  methods: {
    handleClick() { // 点击时间选项卡
      if (this.activeTab == 'prevDay') {
        this.selectDayWeekReport = [new Date().setHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000, this.todayTimeE - 24 * 60 * 60 * 1000]
      } else if (this.activeTab == 'prevWeek') {
        this.selectDayWeekReport = [this.prevWeekS, this.todayTimeE]
      } else if (this.activeTab == 'prevMonth') {
        this.selectDayWeekReport = [this.prevMonthS, this.todayTimeE]
      }
      this.listQuery.startDate = this.listQueryTem.startDate = this.weekReportStartTime = new Date(this.selectDayWeekReport[0]).getTime()
      this.listQuery.endDate = this.listQueryTem.endDate = this.weekReportEndTime = new Date(this.selectDayWeekReport[1]).getTime()
      // console.log(this.weekReportStartTime, '--', this.weekReportEndTime)
      this.initDeviceStatistic()
    },
    queryList() {
      var param1 = {
        mcuId: this.$route.query.mcuId,
        myToken: this.$store.state.token
      }
      findDeviceInfo(param1).then(res => { // 基本信息
        // console.log(res.resultModel)
        this.basicinfo = res.resultModel
        if (this.basicinfo.batteryVoltage) { this.basicinfo.batteryVoltage = this.basicinfo.batteryVoltage > 900 ? (this.basicinfo.batteryVoltage / 100) : this.basicinfo.batteryVoltage } else { this.basicinfo.batteryVoltage = '--' }
        if (this.basicinfo.batteryCapacity) { this.basicinfo.batteryCapacity = this.basicinfo.batteryCapacity > 100 ? Math.round(this.basicinfo.batteryCapacity / 100) : this.basicinfo.batteryCapacity } else { this.basicinfo.batteryCapacity = '--' }
      })
    },
    changeSearchWeekReport() { // 日期选择器
      if (this.selectDayWeekReport) { // 选择了时间
        this.listQuery.startDate = this.listQueryTem.startDate = this.weekReportStartTime = new Date(this.selectDayWeekReport[0]).getTime()
        this.listQuery.endDate = this.listQueryTem.endDate = this.weekReportEndTime = new Date(this.selectDayWeekReport[1]).getTime() + 24 * 60 * 60 * 1000 - 1000
      } else {
        this.listQuery.endDate = this.listQueryTem.endDate = this.weekReportEndTime = this.$route.query.latest ? this.upadateLast : this.todayLast
        this.listQuery.startDate = this.listQueryTem.startDate = this.weekReportStartTime = this.$route.query.latest ? (this.upadateLast - 1000 * 60 * 60 * 24 * 7 + 1000) : (this.todayLast - 7 * 24 * 60 * 60 * 1000 + 1000)
      }
      this.changeActiveTab()
      // this.queryList()
      this.initDeviceStatistic()
    },
    changeActiveTab() { // 根据条件改变选项卡
      if (this.weekReportEndTime == this.todayTimeE) {
        if (this.weekReportStartTime == new Date().setHours(0, 0, 0, 0)) {
          this.activeTab = 'prevDay'
        } else if (this.weekReportStartTime == this.prevWeekS) {
          this.activeTab = 'prevWeek'
        } else if (this.weekReportStartTime == this.prevMonthS) {
          this.activeTab = 'prevMonth'
        } else {
          this.activeTab = ''
        }
      } else {
        this.activeTab = ''
      }
    },
    initDeviceStatistic() {
      var param = {
        mcuId: this.$route.query.mcuId,
        startDate: this.weekReportStartTime,
        endDate: this.weekReportEndTime
      }
      deviceStatistic(param).then(res => {
        if (res.resultCode == 1001) {
          this.lineDate = []
          res.resultModel.forEach(v => {
            this.lineDate.push({ rebootCount: v.rebootCount, summaryTime: v.summaryTime, value: v.rebootCount })
          })
        }
      })
    }
  }
}

</script>
<style lang="scss">
#mainContent{
  .myTable .el-table__body tr:hover>td{
    background-color: #fff!important;
  }
  .searchWarp{
    display: flex;
    align-items: center;
  }
  .selectTab{
    display: inline-block;
    margin-left:20px;
    .el-tabs__header{
      display: inline-block!important;
      margin-bottom: 0;
    }
    .el-tabs__nav{
      background: #dfe4ed6b;
      border-top:none;
    }
    .el-tabs__item{
      border-top: 1px solid #dfe4ed;
      height: 36px;
      line-height: 34px;
    }
    .el-tabs__item.is-active{
      background: #1990fc;
      border-bottom: 1px solid #1990fc;
      border-top: 1px solid #1990fc;
      color:#fff;
    }
    .el-tabs__item:nth-of-type(1).is-active{
      border-radius: 3px 0 0 0;
    }
    .el-tabs__item:nth-of-type(3).is-active{
      border-radius:0 3px 0 0;
    }
  }
}

</style>
